// API Layer Mocks
// This file exports all mock data for development and testing

import { ReportStatus } from '../../../../pure-js/enums/ReportStatus'
import {
  ApiResponse,
  User,
  Session,
  Team,
  TeamStats,
  Group,
  GroupStats,
  Report,
  FacilitatorDashboardData,
  GamerDashboardData
} from '../types'
import { mockFacilitatorDashboard, mockGamerDashboard } from './dashboardMock'
export { mockAchievementData } from './achievements'

// Mock Users
export const mockUsers: User[] = [
  {
    id: '1',
    email: 'admin@interax.com',
    name: 'Admin User',
    avatar: '/avatars/admin.jpg',
    phone: '+1 (555) 123-4567',
    createdAt: '2024-01-01T00:00:00Z',
    updatedAt: '2024-01-01T00:00:00Z'
  },
  {
    id: '2',
    email: 'facilitator@interax.com',
    name: 'John Facilitator',
    avatar: '/avatars/facilitator.jpg',
    phone: '+1 (555) 234-5678',
    createdAt: '2024-01-01T00:00:00Z',
    updatedAt: '2024-01-01T00:00:00Z'
  },
  {
    id: '3',
    email: 'gamer1@interax.com',
    name: 'Alice Gamer',
    avatar: '/avatars/gamer1.jpg',
    completedOnboardingSteps: ['Introduction', 'Assessment', 'GameIntroduction'],
    createdAt: '2024-01-01T00:00:00Z',
    updatedAt: '2024-01-01T00:00:00Z'
  },
  {
    id: '4',
    email: 'gamer2@interax.com',
    name: 'Bob Gamer',
    avatar: '/avatars/gamer2.jpg',
    phone: '+1 (555) 345-6789',
    completedOnboardingSteps: ['Introduction'],
    createdAt: '2024-01-01T00:00:00Z',
    updatedAt: '2024-01-01T00:00:00Z'
  },
  {
    id: '5',
    email: 'sarah@interax.com',
    name: 'Sarah Johnson',
    avatar: '/avatars/sarah.jpg',
    completedOnboardingSteps: ['Introduction', 'Assessment'],
    createdAt: '2024-01-01T00:00:00Z',
    updatedAt: '2024-01-01T00:00:00Z'
  },
  {
    id: '6',
    email: 'mike@interax.com',
    name: 'Mike Chen',
    avatar: '/avatars/mike.jpg',
    phone: '+1 (555) 456-7890',
    completedOnboardingSteps: [],
    createdAt: '2024-01-01T00:00:00Z',
    updatedAt: '2024-01-01T00:00:00Z'
  },
  {
    id: '7',
    email: 'emily@interax.com',
    name: 'Emily Davis',
    avatar: '/avatars/emily.jpg',
    completedOnboardingSteps: ['Introduction', 'Assessment'],
    createdAt: '2024-01-01T00:00:00Z',
    updatedAt: '2024-01-01T00:00:00Z'
  },
  {
    id: '8',
    email: 'darkelfbg@gmail.com',
    name: 'Hristo Stamenov',
    avatar: '/avatars/hristo.jpg',
    phone: '+1 (555) 567-8901',
    completedOnboardingSteps: ['Introduction'],
    createdAt: '2024-01-01T00:00:00Z',
    updatedAt: '2024-01-01T00:00:00Z'
  }
]

// Mock Sessions
export const mockSessions: Session[] = [
  {
    id: '1',
    title: 'Team Building Session',
    description: 'A session focused on building team cohesion',
    startDate: '2024-02-01T10:00:00Z',
    endDate: '2024-02-01T12:00:00Z',
    status: 'completed',
    teamId: 't1',
    participants: [mockUsers[1], mockUsers[2]],
    facilitator: mockUsers[0],
    createdAt: '2024-01-15T00:00:00Z',
    updatedAt: '2024-01-15T00:00:00Z'
  },
  {
    id: '2',
    title: 'Leadership Workshop',
    description: 'Developing leadership skills in gaming context',
    startDate: '2024-02-05T14:00:00Z',
    endDate: '2024-02-05T16:00:00Z',
    status: 'completed',
    teamId: 't2',
    participants: [mockUsers[1]],
    facilitator: mockUsers[0],
    createdAt: '2024-01-20T00:00:00Z',
    updatedAt: '2024-01-20T00:00:00Z'
  },
  {
    id: '3',
    title: 'Communication Skills Training',
    description: 'Enhancing team communication and collaboration',
    startDate: '2024-02-10T09:00:00Z',
    endDate: '2024-02-10T11:00:00Z',
    status: 'completed',
    teamId: 't1',
    participants: [mockUsers[2], mockUsers[3]],
    facilitator: mockUsers[0],
    createdAt: '2024-01-25T00:00:00Z',
    updatedAt: '2024-01-25T00:00:00Z'
  },
  {
    id: '4',
    title: 'Problem Solving Workshop',
    description: 'Creative problem-solving techniques and strategies',
    startDate: '2024-02-15T13:00:00Z',
    endDate: '2024-02-15T15:00:00Z',
    status: 'completed',
    teamId: 't3',
    participants: [mockUsers[3], mockUsers[4]],
    facilitator: mockUsers[0],
    createdAt: '2024-02-01T00:00:00Z',
    updatedAt: '2024-02-01T00:00:00Z'
  },
  {
    id: '5',
    title: 'Innovation Lab Session',
    description: 'Exploring innovative approaches to team challenges',
    startDate: '2024-02-20T10:00:00Z',
    endDate: '2024-02-20T12:00:00Z',
    status: 'completed',
    teamId: 't2',
    participants: [mockUsers[4], mockUsers[5]],
    facilitator: mockUsers[0],
    createdAt: '2024-02-05T00:00:00Z',
    updatedAt: '2024-02-05T00:00:00Z'
  }
]

// Mock Teams with correct types
export const mockTeams: Team[] = [
  {
    id: 't1',
    name: 'Alpha Team',
    description: 'High-performing team focused on innovation',
    members: [mockUsers[0], mockUsers[1], mockUsers[2], mockUsers[3]],
    sessions: [mockSessions[0], mockSessions[1]],
    leader: mockUsers[0],
    status: 'active',
    memberCount: 4,
    lastActivity: '2024-01-15',
    createdAt: '2024-01-01T00:00:00Z',
    updatedAt: '2024-01-15T00:00:00Z',
    code: 'ALPHA123',
    metaData: {
      wherebyMeetings: [
        {
          meetingId: 'mock-meeting-alpha',
          roomName: 'mock-room-alpha',
          roomUrl: 'https://intraction-ab.whereby.com/mock-room-alpha',
          hostRoomUrl: 'https://intraction-ab.whereby.com/mock-room-alpha?roomKey=mockHostKey',
          startDate: new Date().toISOString(),
          endDate: new Date(Date.now() + 24 * 60 * 60 * 1000).toISOString(),
          isLocked: false,
          roomMode: 'normal',
          templateType: 'standard'
        }
      ],
      wherebyRoomNames: ['mock-room-alpha']
    }
  },
  {
    id: 't2',
    name: 'Beta Team',
    description: 'Collaborative team with diverse skills',
    members: [mockUsers[1], mockUsers[2], mockUsers[3]],
    sessions: [mockSessions[1], mockSessions[2]],
    leader: mockUsers[1],
    status: 'active',
    memberCount: 3,
    lastActivity: '2024-01-20',
    createdAt: '2024-01-05T00:00:00Z',
    updatedAt: '2024-01-20T00:00:00Z',
    code: 'BETA456'
  },
  {
    id: 't3',
    name: 'Gamma Team',
    description: 'Specialized team for technical projects',
    members: [mockUsers[2], mockUsers[3], mockUsers[0], mockUsers[1]],
    sessions: [mockSessions[2], mockSessions[0]],
    leader: mockUsers[2],
    status: 'active',
    memberCount: 4,
    lastActivity: '2024-01-25',
    createdAt: '2024-01-10T00:00:00Z',
    updatedAt: '2024-01-25T00:00:00Z',
    code: 'GAMMA789'
  },
  {
    id: 't4',
    name: 'Delta Team',
    description: 'Cross-functional team for strategic initiatives',
    members: [mockUsers[3], mockUsers[0], mockUsers[1], mockUsers[2]],
    sessions: [mockSessions[0], mockSessions[1]],
    leader: mockUsers[3],
    status: 'active',
    memberCount: 4,
    lastActivity: '2024-02-01',
    createdAt: '2024-01-15T00:00:00Z',
    updatedAt: '2024-02-01T00:00:00Z',
    code: 'DELTA012'
  },
  {
    id: 't5',
    name: 'Epsilon Team',
    code: 'EPSILON345',
    description: 'Agile team focused on rapid delivery',
    members: [mockUsers[0], mockUsers[1], mockUsers[2]],
    sessions: [mockSessions[1], mockSessions[2]],
    leader: mockUsers[0],
    status: 'active',
    memberCount: 3,
    lastActivity: '2024-02-05',
    createdAt: '2024-01-20T00:00:00Z',
    updatedAt: '2024-02-05T00:00:00Z'
  }
]

// Mock Reports (using pure-js Report type)
export const mockReports: Report[] = [
  {
    id: '1',
    title: 'Team Building Session Report',
    status: ReportStatus.DRAFT,
    userId: mockUsers[0].id,
    sprintIds: ['sprint-1'],
    sessionIds: ['1'],
    teamIds: ['t1'],
    reportData: {},
    createdAt: '2024-02-01T13:00:00Z',
    updatedAt: '2024-02-01T13:00:00Z'
  },
  {
    id: '2',
    title: 'Finalized Team Report',
    status: ReportStatus.FINALIZED,
    userId: mockUsers[0].id,
    sprintIds: ['sprint-2'],
    sessionIds: ['2'],
    teamIds: ['t2'],
    reportData: {},
    createdAt: '2024-01-15T10:00:00Z',
    updatedAt: '2024-01-20T14:00:00Z',
    finalizedAt: '2024-01-20T14:00:00Z'
  }
]

// Mock Team Statistics
export const mockTeamStats: TeamStats = {
  totalTeams: 3,
  activeTeams: 2,
  totalMembers: 6,
  averageTeamSize: 2
}

// Group Mock Data
export const mockGroups: Group[] = [
  {
    id: 'g1',
    name: 'Leadership Development Program',
    description: 'Comprehensive leadership training program for emerging leaders',
    teams: [mockTeams[0], mockTeams[1], mockTeams[2]],
    createdAt: '2024-01-01T00:00:00Z',
    updatedAt: '2024-01-25T00:00:00Z',
    status: 'active'
  },
  {
    id: 'g2',
    name: 'Sales Excellence Initiative',
    description: 'Regional sales training and development program',
    teams: [mockTeams[3], mockTeams[4]],
    createdAt: '2024-01-15T00:00:00Z',
    updatedAt: '2024-02-15T00:00:00Z',
    status: 'active'
  },
  {
    id: 'g3',
    name: 'Innovation Workshop Series',
    description: 'Creative problem-solving and innovation training',
    teams: [mockTeams[0], mockTeams[2]],
    createdAt: '2024-02-01T00:00:00Z',
    updatedAt: '2024-02-25T00:00:00Z',
    status: 'active'
  }
]

export const mockGroupStats: GroupStats = {
  totalGroups: 3,
  activeGroups: 3,
  totalTeams: 9,
  totalMembers: 33,
  averageTeamsPerGroup: 3,
  averageMembersPerTeam: 3.67
}

// Mock data by entity type
export const mockData = {
  // Data arrays
  users: mockUsers,
  sessions: mockSessions,
  teams: mockTeams,
  reports: mockReports,
  groups: mockGroups,
  teamStats: mockTeamStats,
  groupStats: mockGroupStats,

  // User functions
  getUsers: async (_filters?: Record<string, any>): Promise<ApiResponse<User[]>> => {
    await simulateApiDelay()
    return { data: mockUsers, success: true } as ApiResponse<User[]>
  },

  getUser: async (id: string): Promise<ApiResponse<User>> => {
    await simulateApiDelay()
    const user = mockUsers.find((u) => u.id === id)
    return { data: user!, success: true } as ApiResponse<User>
  },

  getCurrentUser: async (): Promise<ApiResponse<User>> => {
    await simulateApiDelay()
    return { data: mockUsers[0], success: true } as ApiResponse<User>
  },

  getUserProfile: async (): Promise<ApiResponse<User>> => {
    await simulateApiDelay()
    return { data: mockUsers[0], success: true } as ApiResponse<User>
  },

  updateUser: async (id: string, userData: Partial<User>): Promise<ApiResponse<User>> => {
    await simulateApiDelay()
    const userIndex = mockUsers.findIndex((u) => u.id === id)
    if (userIndex === -1) {
      return { data: {} as User, success: false, error: 'User not found' } as ApiResponse<User>
    }

    // Update the user in the mock array
    mockUsers[userIndex] = {
      ...mockUsers[userIndex],
      ...userData,
      updatedAt: new Date().toISOString()
    }

    return { data: mockUsers[userIndex], success: true } as ApiResponse<User>
  },

  // Session functions
  getSessions: async (_filters?: Record<string, any>): Promise<ApiResponse<Session[]>> => {
    await simulateApiDelay()
    return { data: mockSessions, success: true } as ApiResponse<Session[]>
  },

  getSession: async (id: string): Promise<ApiResponse<Session>> => {
    await simulateApiDelay()
    const session = mockSessions.find((s) => s.id === id)
    return { data: session!, success: true } as ApiResponse<Session>
  },

  getUpcomingSessions: async (): Promise<ApiResponse<Session[]>> => {
    await simulateApiDelay()
    return { data: mockSessions.filter((s) => s.status === 'scheduled'), success: true } as ApiResponse<Session[]>
  },

  getPastSessions: async (): Promise<ApiResponse<Session[]>> => {
    await simulateApiDelay()
    return { data: mockSessions.filter((s) => s.status === 'completed'), success: true } as ApiResponse<Session[]>
  },

  getActiveSessions: async (): Promise<ApiResponse<Session[]>> => {
    await simulateApiDelay()
    return { data: mockSessions.filter((s) => s.status === 'active'), success: true } as ApiResponse<Session[]>
  },

  getSessionsByFacilitator: async (facilitatorId: string): Promise<ApiResponse<Session[]>> => {
    await simulateApiDelay()
    return { data: mockSessions.filter((s) => s.facilitator.id === facilitatorId), success: true } as ApiResponse<
      Session[]
    >
  },

  getSessionsByParticipant: async (_participantId: string): Promise<ApiResponse<Session[]>> => {
    await simulateApiDelay()
    return { data: mockSessions, success: true } as ApiResponse<Session[]>
  },

  // Team functions
  getTeams: async (_filters?: Record<string, any>): Promise<ApiResponse<Team[]>> => {
    await simulateApiDelay()
    return { data: mockTeams, success: true } as ApiResponse<Team[]>
  },

  getTeam: async (id: string): Promise<ApiResponse<Team>> => {
    await simulateApiDelay()
    const team = mockTeams.find((t) => t.id === id)
    return { data: team!, success: true } as ApiResponse<Team>
  },

  getTeamsByMember: async (_memberId: string): Promise<ApiResponse<Team[]>> => {
    await simulateApiDelay()
    return { data: mockTeams, success: true } as ApiResponse<Team[]>
  },

  getActiveTeams: async (): Promise<ApiResponse<Team[]>> => {
    await simulateApiDelay()
    return { data: mockTeams.filter((t) => t.status === 'active'), success: true } as ApiResponse<Team[]>
  },

  getTeamStats: async (): Promise<ApiResponse<TeamStats>> => {
    await simulateApiDelay()
    return { data: mockTeamStats, success: true } as ApiResponse<TeamStats>
  },

  // Group functions
  getGroups: async (_filters?: Record<string, any>): Promise<ApiResponse<Group[]>> => {
    await simulateApiDelay()
    return { data: mockGroups, success: true } as ApiResponse<Group[]>
  },

  getGroup: async (id: string): Promise<ApiResponse<Group>> => {
    await simulateApiDelay()
    const group = mockGroups.find((g) => g.id === id)
    return { data: group!, success: true } as ApiResponse<Group>
  },

  getGroupsWithTeams: async (): Promise<ApiResponse<Group[]>> => {
    await simulateApiDelay()
    return { data: mockGroups, success: true } as ApiResponse<Group[]>
  },

  getActiveGroups: async (): Promise<ApiResponse<Group[]>> => {
    await simulateApiDelay()
    return { data: mockGroups.filter((g) => g.status === 'active'), success: true } as ApiResponse<Group[]>
  },

  // Report functions
  getReports: async (_filters?: Record<string, any>): Promise<ApiResponse<Report[]>> => {
    await simulateApiDelay()
    return { data: mockReports, success: true } as ApiResponse<Report[]>
  },

  getReport: async (id: string): Promise<ApiResponse<Report>> => {
    await simulateApiDelay()
    const report = mockReports.find((r) => r.id === id)
    return { data: report!, success: true } as ApiResponse<Report>
  },

  getReportsBySession: async (_sessionId: string): Promise<ApiResponse<Report[]>> => {
    await simulateApiDelay()
    return { data: mockReports, success: true } as ApiResponse<Report[]>
  },

  getReportsByTeam: async (_teamId: string): Promise<ApiResponse<Report[]>> => {
    await simulateApiDelay()
    return { data: mockReports, success: true } as ApiResponse<Report[]>
  },

  getReportsByUser: async (_userId: string): Promise<ApiResponse<Report[]>> => {
    await simulateApiDelay()
    return { data: mockReports, success: true } as ApiResponse<Report[]>
  },

  getGeneratedReports: async (): Promise<ApiResponse<Report[]>> => {
    await simulateApiDelay()
    return { data: mockReports, success: true } as ApiResponse<Report[]>
  },

  // Dashboard functions
  getFacilitatorDashboard: async (): Promise<ApiResponse<FacilitatorDashboardData>> => {
    await simulateApiDelay()
    return { data: mockFacilitatorDashboard, success: true } as ApiResponse<FacilitatorDashboardData>
  },

  getGamerDashboard: async (): Promise<ApiResponse<GamerDashboardData>> => {
    await simulateApiDelay()
    return { data: mockGamerDashboard, success: true } as ApiResponse<GamerDashboardData>
  },

  getDashboardStats: async (): Promise<ApiResponse<any>> => {
    await simulateApiDelay()
    return { data: mockTeamStats, success: true } as ApiResponse<any>
  },

  getRecentActivity: async (): Promise<ApiResponse<any>> => {
    await simulateApiDelay()
    return { data: mockSessions.slice(0, 10), success: true } as ApiResponse<any>
  },

  // Training Sprint functions
  getTrainingSprints: async (_filters?: Record<string, any>): Promise<ApiResponse<any>> => {
    await simulateApiDelay()
    return { data: [], success: true } as ApiResponse<any>
  },

  getTrainingSprint: async (_id: string): Promise<ApiResponse<any>> => {
    await simulateApiDelay()
    return { data: {}, success: true } as ApiResponse<any>
  },

  getActiveTrainingSprints: async (): Promise<ApiResponse<any>> => {
    await simulateApiDelay()
    return { data: [], success: true } as ApiResponse<any>
  },

  getUpcomingTrainingSprints: async (): Promise<ApiResponse<any>> => {
    await simulateApiDelay()
    return { data: [], success: true } as ApiResponse<any>
  },

  // Search functions
  globalSearch: async (_query: string): Promise<ApiResponse<any>> => {
    await simulateApiDelay()
    return { data: { users: [], sessions: [], teams: [] }, success: true } as ApiResponse<any>
  },

  searchUsers: async (query: string): Promise<ApiResponse<User[]>> => {
    await simulateApiDelay()
    return {
      data: mockUsers.filter((u) => u.name.toLowerCase().includes(query.toLowerCase())),
      success: true
    } as ApiResponse<User[]>
  },

  searchSessions: async (query: string): Promise<ApiResponse<Session[]>> => {
    await simulateApiDelay()
    return {
      data: mockSessions.filter((s) => s.title.toLowerCase().includes(query.toLowerCase())),
      success: true
    } as ApiResponse<Session[]>
  },

  // Configuration functions
  getAppConfig: async (): Promise<ApiResponse<any>> => {
    await simulateApiDelay()
    return { data: { features: {} }, success: true } as ApiResponse<any>
  },

  getUserConfig: async (): Promise<ApiResponse<any>> => {
    await simulateApiDelay()
    return { data: { preferences: {} }, success: true } as ApiResponse<any>
  }
}

// Helper function to get mock data by ID
export const getMockDataById = <T extends { id: string }>(data: T[], id: string): T | undefined => {
  return data.find((item) => item.id === id)
}

// Helper function to simulate API delay
export const simulateApiDelay = (ms: number = 500): Promise<void> => {
  return new Promise((resolve) => setTimeout(resolve, ms))
}
